const PLAYER_STATUS = {
  PLAYING: 'playing',
  PAUSED: 'paused',
  STOPPED: 'stopped',
  READY: 'ready',
  IDLE: 'idle'
};

export default PLAYER_STATUS;
